import { render, staticRenderFns } from "./TrainingGroupFolderNew.vue?vue&type=template&id=32d9196e&scoped=true&"
import script from "./TrainingGroupFolderNew.vue?vue&type=script&lang=js&"
export * from "./TrainingGroupFolderNew.vue?vue&type=script&lang=js&"
import style0 from "./TrainingGroupFolderNew.vue?vue&type=style&index=0&id=32d9196e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9196e",
  null
  
)

export default component.exports